import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../axios.config';
import { QuizsTable } from '../components/Quiz/QuizsTable';
import { UpdateQuizModal } from '../components/Quiz/UpdateQuizModal';
import { CreateQuizModal } from '../components/Quiz/CreateQuizModal';
import { Box, Button, Typography } from '@mui/material';
import { ContentBlock } from '../shared/sharedStyles';
import AddIcon from '@mui/icons-material/Add';

const Quiz = () => {
    const lngsltd = JSON.parse(localStorage.getItem('languageSelected'));
    const navigate = useNavigate();
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [showAdd, setShowAdd] = useState(false);
    const handleCloseAdd = () => {
        setShowAdd(false);
        clear();
        clearErrors();
    };
    const handleShowAdd = () => setShowAdd(true);

    const [data, setData] = useState([]);
    const [editID, setEditID] = useState('');
    const [editTitle, setEditTitle] = useState('');
    const [editDescription, setEditDescription] = useState('');
    const [editCourseID, setEditCourseID] = useState('');
    const [newTitle, setNewTitle] = useState('');
    const [newDescription, setNewDescription] = useState('');
    const [newCourseID, setNewCourseID] = useState('');
    const [courseData, setCourseData] = useState([]);

    //Error Handling
    const [courseNameError, setCourseNameError] = useState('');
    const [quizTitleError, setQuizTitleError] = useState('');

    const [editCourseNameError, setEditCourseNameError] = useState('');
    const [editQuizTitleError, setEditQuizTitleError] = useState('');
    const [dynamicText, setDynamicText] = useState(lngsltd["Loading...Please wait"]);


    useEffect(() => {
        getData();
        fetchCourseData();
    }, []);

    const getData = () => {
        axiosInstance.get(`/Quiz`)
            .then((result) => {
                const responseData = result.data;
                if (typeof responseData === 'string') {
                    setDynamicText(responseData);
                } else {
                    setData(result.data);
                    clear();
                }
            })
            .catch((error) => {
                // console.log(error);
            });
    };

    const fetchCourseData = () => {
        axiosInstance.get(`/Course`)
            .then((result) => {
                setCourseData(result.data);
            })
            .catch((error) => {
                // console.log(error);
            });
    };

    const handleEdit = (id) => {
        axiosInstance.get(`/Quiz/${id}`)
            .then((result) => {
                setEditID(id);
                setEditTitle(result.data.title);
                setEditDescription(result.data.description);
                setEditCourseID(result.data.courseID);
                handleShow();
            })
            .catch((error) => {
                // console.log(error);
            });
    };

    const handleDelete = (id) => {
        if (window.confirm(lngsltd['Are you sure you want to delete this quiz?'])) {
            axiosInstance.delete(`/Quiz/${id}`)
                .then((result) => {
                    toast.success(lngsltd['Quiz has been deleted']);
                    getData();
                })
                .catch((error) => {
                    toast.error(error);
                });
        }
    };

    const handleUpdate = () => {
        let formIsValid = true;

        if (!editCourseID) {
            setEditCourseNameError(lngsltd['Please select a CourseName']);
            formIsValid = false;
        } else {
            setEditCourseNameError('');
        }

        if (!editTitle) {
            setEditQuizTitleError(lngsltd['Quiz Title is required']);
            formIsValid = false;
        } else {
            setEditQuizTitleError('');
        }

        if (formIsValid) {
            const url = `/Quiz/${editID}`;
            const data = {
                "quizID": editID,
                "courseID": editCourseID,
                "title": editTitle,
                "description": editDescription

            };
            axiosInstance.put(url, data)
                .then((result) => {
                    handleClose();
                    getData();
                    clear();
                    toast.success(lngsltd['Quiz has been updated']);
                })
                .catch((error) => {
                    toast.error(error);
                });
        }
    };

    const handleSave = () => {
        let formIsValid = true;

        if (!newCourseID) {
            setCourseNameError(lngsltd['Please select a CourseName']);
            formIsValid = false;
        } else {
            setCourseNameError('');
        }

        if (!newTitle) {
            setQuizTitleError(lngsltd['Quiz Title is required']);
            formIsValid = false;
        } else {
            setQuizTitleError('');
        }

        if (formIsValid) {
            const url = `/Quiz`;
            const data = {
                "quizID": 0,
                "courseID": newCourseID,
                "title": newTitle,
                "description": newDescription

            };
            axiosInstance.post(url, data)
                .then((result) => {
                    handleCloseAdd();
                    getData();
                    clear();
                    toast.success(lngsltd['New quiz has been added']);
                })
                .catch((error) => {
                    toast.error(error);
                });
        }
    };

    const handleAddQuestions = (quizid) => {
        navigate(`/quiz-questions/${quizid}`);
    }

    const clearErrors = () => {
        setCourseNameError('');
        setQuizTitleError('');
        setEditCourseNameError('');
        setEditQuizTitleError('');
    };

    const clear = () => {
        setEditID('');
        setEditTitle('');
        setEditDescription('');
        setEditCourseID('');
        setNewTitle('');
        setNewDescription('');
        setNewCourseID('');
    };

    return (
        <Box className='fullHW' px={6} py={4} display="flex" flexDirection="column">
            <Typography variant="h5" fontWeight={600}>{lngsltd["List of Quizzes"]}</Typography>
            <ContentBlock sx={{ flexGrow: 1, display: "flex", flexDirection: "column", py: 4, "& p": { m: 0 } }}>
                <ToastContainer 
                autoClose={2000} 
                progressClassName= 'custom-toast-progress-bar'/>
                <Box display="flex" justifyContent="flex-end" width="100%">
                    <Button size="large" variant="contained" onClick={() => setShowAdd(true)} startIcon={<AddIcon />} sx={{ textTransform: "initial" }}>
                        {lngsltd["Add Quiz"]}
                    </Button>
                </Box>
                <Box mt={2} flexGrow={1} overflow="hidden" width="90%">
                    <QuizsTable
                        lngsltd={lngsltd}
                        data={data}
                        dynamicText={dynamicText}
                        courseData={courseData}
                        handleEdit={handleEdit}
                        handleDelete={handleDelete}
                        handleAddQuestions={handleAddQuestions}
                    />
                </Box>

                <UpdateQuizModal
                    show={show}
                    handleClose={handleClose}
                    lngsltd={lngsltd}
                    editCourseID={editCourseID}
                    setEditCourseID={setEditCourseID}
                    courseData={courseData}
                    editCourseNameError={editCourseNameError}
                    editTitle={editTitle}
                    setEditTitle={setEditTitle}
                    editQuizTitleError={editQuizTitleError}
                    editDescription={editDescription}
                    setEditDescription={setEditDescription}
                    handleUpdate={handleUpdate}
                />
                
                <CreateQuizModal
                    showAdd={showAdd}
                    handleCloseAdd={handleCloseAdd}
                    lngsltd={lngsltd}
                    newCourseID={newCourseID}
                    setNewCourseID={setNewCourseID}
                    courseData={courseData}
                    courseNameError={courseNameError}
                    newTitle={newTitle}
                    setNewTitle={setNewTitle}
                    quizTitleError={quizTitleError}
                    newDescription={newDescription}
                    setNewDescription={setNewDescription}
                    handleSave={handleSave}
                />
            </ContentBlock>
        </Box>
    );
};

export default Quiz;